import React, {
  useState, useCallback, useEffect, useMemo,
} from 'react';
import {
  Message, Divider, Icon,
} from 'semantic-ui-react';
import {
  Link,
} from 'react-router-dom';
import {
  Other,
} from 'simplydo/interfaces';
import { useAppSelector } from 'store';
import api from 'api';
import util from 'utils/utils';

type ChallengeProblemInfo = Other.IProblemInfo

type ChallengeProblemsProps = {
  challenge: Other.IChallenge;
}

const ChallengeProblems = ({
  challenge,
}: ChallengeProblemsProps) => {
  const [challengeProblemInfo, setChallengeProblemInfo] = useState<ChallengeProblemInfo | null>(null);
  const user: Other.IUser = useAppSelector((state) => state.user);
  const challengeId = challenge._id;

  const canManage = useMemo(() => util.canManageChallenge(user, challenge), [user, challenge]);

  const getProblems = useCallback(() => {
    if (canManage) {
      api.challenges.getProblems(challengeId, (data) => {
        setChallengeProblemInfo(data);
      }, () => {});
    }
  }, [canManage, challengeId]);

  useEffect(() => {
    getProblems();
  }, [getProblems]);

  if (challengeProblemInfo?.usersNotInAudience) {
    return (
      <Message
        error
        icon
      >
        <Icon name='warning sign' />
        <Message.Content>
          <Message.Header>{util.pluralise(challengeProblemInfo.usersNotInAudience.assessors.length + challengeProblemInfo.usersNotInAudience.assignees.length, 'user', 'users')} cannot currently view this challenge</Message.Header>
          <Divider hidden />
          <Message.Content>
            This challenge has assignees or assessors that aren't currently in the audience. Idea assignees or assessors not in the challenge's audience will not be able to view the challenge and may not be able to find their assigned ideas.
          </Message.Content>
          <Divider hidden />
          {challengeProblemInfo.usersNotInAudience.assessors.length > 0
            ? (
              <>
                <Message.Content>
                  The following assessors are not currently in the audience: <b>{challengeProblemInfo.usersNotInAudience.assessorUsers.map((assessor) => assessor.profile.fullName).join(', ')}</b>
                </Message.Content>
                <Divider hidden />
              </>
            ) : null
          }
          {challengeProblemInfo.usersNotInAudience.assignees.length > 0
            ? (
              <>
                <Message.Content>
                  The following project assignees are not currently in the audience: <b>{challengeProblemInfo.usersNotInAudience.assigneeUsers.map((assignee) => assignee.profile.fullName).join(', ')}</b>
                </Message.Content>
                <Divider hidden />
              </>

            ) : null
          }
          <Link to={`/challenges/${challengeId}/settings`}>
            Click here to configure the challenge settings
          </Link>
        </Message.Content>

      </Message>
    );
  }
  return null;
};

export default ChallengeProblems;
